import { jsx, jsxs } from "react/jsx-runtime";
import { Box, FormControl, FormHelperText, FormLabel } from "@mui/material";
import {
  RangeCalendar
} from "../../../../components/calendars/RangeCalendar/index.js";
import { CalendarRoot } from "../../../../components/calendars/context/index.js";
import { useTidalFormBridge } from "../../utils/useTidalFormBridge.js";
const defaultComponentValue = {};
function DateRangePicker(props) {
  const {
    variant = "standard",
    calendarProps,
    configuration = {},
    initialValue = defaultComponentValue,
    validateOn = "change",
    ...bridgeOptions
  } = props;
  const {
    config: { fullWidth, label: bridgeLabel, testId = "daterangepicker-root" },
    fieldInfo: {
      errorOrHelperText,
      field: { required, visible },
      fieldDisabled,
      fieldHasError,
      onChange,
      showErrorAccent,
      showHelperText,
      value
    }
  } = useTidalFormBridge({
    ...bridgeOptions,
    validateOn,
    initialValue
  });
  if (!visible) return null;
  const dataTidal = "DateRangePicker";
  const label = props.variant === "standard" ? bridgeLabel : "";
  const formControlProps = props.variant === "standard" ? props.formControlProps : {};
  const { start: selectionStart, end: selectionEnd } = value;
  const handleOnChange = (_newDate, range) => {
    onChange({ start: range[0], end: range[1] });
  };
  const calendarConfig = {
    ...configuration,
    readonly: fieldDisabled
  };
  const calendarComponent = /* @__PURE__ */ jsx(CalendarRoot, { configuration: calendarConfig, children: /* @__PURE__ */ jsx(
    RangeCalendar,
    {
      ...calendarProps,
      onChange: handleOnChange,
      selectionEnd,
      selectionStart
    }
  ) });
  return variant === "standard" ? /* @__PURE__ */ jsxs(
    FormControl,
    {
      ...formControlProps,
      fullWidth,
      error: showErrorAccent && fieldHasError,
      required,
      "data-tidal": dataTidal,
      "data-testid": testId,
      "data-tidal-form-field-name": bridgeOptions.name,
      sx: {
        gap: 1,
        alignItems: "flex-start",
        "&.tidal-form-devtool-highlight": (theme) => ({
          outline: `4px solid var(--tidal-devtools-highlight-color, ${theme.vars.palette.error.dark})`
        })
      },
      children: [
        /* @__PURE__ */ jsx(FormLabel, { children: label }),
        calendarComponent,
        showHelperText && /* @__PURE__ */ jsx(FormHelperText, { error: fieldHasError, children: errorOrHelperText })
      ]
    }
  ) : /* @__PURE__ */ jsx(
    Box,
    {
      "data-tidal": dataTidal,
      "data-testid": testId,
      "data-tidal-form-field-name": bridgeOptions.name,
      sx: {
        gap: 1,
        alignItems: "flex-start",
        "&.tidal-form-devtool-highlight": (theme) => ({
          outline: `4px solid var(--tidal-devtools-highlight-color, ${theme.vars.palette.error.dark})`
        })
      },
      children: calendarComponent
    }
  );
}
export {
  DateRangePicker
};
//# sourceMappingURL=DateRangePicker.js.map
